<template>
  <article
    class="col-md-18"
    :class="{
      loading: isLoading,
    }"
  >
    <h1>User</h1>
    <form novalidate>
      <div class="form-group row">
        <label for="username" class="col">Email:</label>
        <input
          type="text"
          class="form-control col col-12"
          :class="{
            'is-invalid': $v.user.username.$error,
          }"
          id="username"
          v-model="user.username"
          @change="$v.user.username.$touch()"
        />
      </div>
      <div class="form-group row">
        <label for="roles" class="col">Roles:</label>
        <select
          multiple
          v-model="user.roles"
          id="roles"
          class="custom-select col col-12"
          :class="{
            'is-invalid': $v.user.roles.$error,
          }"
        >
          <option v-for="role in roles" :key="role" :value="role">{{
            role
          }}</option>
        </select>
      </div>
      <div class="form-group row">
        <label for="enabled" class="col">Enabled:</label>
        <div class="col col-12 pl-4">
          <input
            type="checkbox"
            class="form-check-input"
            id="enabled"
            v-model="user.enabled"
          />
        </div>
      </div>
      <button
        type="submit"
        @click.prevent="save(user)"
        class="btn btn-sm btn-primary mr-2"
      >
        Save
      </button>
    </form>

    <div class="mt-4" v-if="user.id">
      <h2>Update user password</h2>
      <form novalidate>
        <div class="form-group row">
          <label for="password" class="col">Password:</label>
          <input
            type="password"
            class="form-control col col-12"
            :class="{
              'is-invalid': $v.password.$error,
            }"
            id="password"
            v-model="password"
            @change="$v.password.$touch()"
          />
        </div>
        <button
          type="submit"
          @click.prevent="savePassword(user, password)"
          class="btn btn-sm btn-primary mr-2"
        >
          Update password
        </button>
      </form>
    </div>

    <router-link
      class="btn btn-secondary mt-3"
      :to="'/secure/resellers/' + $route.params.id"
    >
      Back to reseller
    </router-link>
  </article>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'
import loading from '../mixins/loading'

export default {
  mixins: [loading],
  data() {
    return {
      loading: {
        getUser: false,
        save: false,
      },
      user: {
        id: undefined,
        username: '',
        roles: [],
        enabled: true,
      },
      password: '',
      roles: ['Admin', 'Reseller'],
    }
  },
  validations: {
    user: {
      username: {
        required,
        email,
      },
      roles: {
        atLeastOne: value => value.length > 0,
      },
    },
    password: {
      required,
    },
  },
  computed: {},
  methods: {
    ...mapActions('toast', ['addToast']),
    getUser(id) {
      this.loading.getUser = true
      axios
        .get(`/rest/reseller/${this.$route.params.id}/user/${id}`)
        .then(response => (this.user = response.data))
        .finally(() => (this.loading.getUser = false))
    },
    save(user) {
      this.$v.user.$touch()
      if (this.$v.user.$invalid) {
        return
      }

      this.loading.save = true
      axios(`/rest/reseller/${this.$route.params.id}/user/${user.id || ''}`, {
        method: user.id ? 'PUT' : 'POST',
        data: user,
      })
        .then(response => {
          if (!this.user.id) {
            this.user = response.data
            this.$router.replace(
              `/secure/resellers/${this.$route.params.id}/users/${this.user.id}`
            )
          }

          this.addToast({
            message: `User ${this.user.username} saved`,
            type: 'success',
          })
        })
        .finally(() => (this.loading.save = false))
    },
    savePassword(user, password) {
      this.loading.savePassword = true
      axios(
        `/rest/reseller/${this.$route.params.id}/user/${user.id}/setPassword`,
        {
          method: 'POST',
          data: password,
          headers: { 'Content-Type': 'application/json' },
        }
      )
        .then(() => {
          this.addToast({
            message: 'Password updated',
            type: 'success',
          })
        })
        .finally(() => (this.loading.savePassword = false))
    },
  },
  beforeMount() {
    if (this.$route.params.userId !== 'new') {
      this.getUser(this.$route.params.userId)
    }
  },
}
</script>

<style lang="scss"></style>
